// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AQRuJ","icon":"styles_icon__GWjYf"};